<template>
  <div class="legal-page">
    <div class="legal-container">
      <div class="breadcrumb-bar">
        <span class="crumb" @click="$router.push('/')">首页</span>
        <span class="sep">/</span>
        <span class="crumb-current">隐私政策</span>
      </div>

      <h1 class="legal-title">辰鳗科技集团有限公司官方网站隐私政策</h1>
      <p class="legal-updated">生效日期：2026年8月27日　　更新日期：2026年8月24日</p>

      <section class="legal-section">
        <p class="legal-intro"><strong>引言</strong></p>
        <p>
          欢迎访问辰鳗科技集团有限公司（以下简称"我们""本公司"）官方网站（域名：www.smalleel.com，以下简称"本网站"）。本公司是一家专注于综合能源管理与能源数字化的科技企业，业务涵盖能源管理SaaS平台与物联网计量、合同能源管理（EMC）、分布式光伏、储能以及充换电等领域。
        </p>
        <p>
          我们深知个人信息对您的重要性，将严格遵守《中华人民共和国个人信息保护法》《中华人民共和国网络安全法》《中华人民共和国数据安全法》《网络数据安全管理条例》等法律法规，按照"合法、正当、必要、诚信"及最小必要原则处理您的个人信息，不以误导、欺诈、胁迫的方式收集个人信息，不以默认勾选、功能捆绑等形式强制您同意。
        </p>
        <p class="legal-emphasis">
          <strong>【重点提示】</strong
          >请您在访问、浏览、使用本网站前，仔细阅读并充分理解本政策全部内容，特别是关于个人信息收集范围、共享与跨境提供、您的权利行使方式等条款。您勾选同意、或在阅读提示后继续使用本网站需提交个人信息的功能，即视为您已阅读、理解并同意本政策。如您不同意本政策的任何内容，请勿使用相应功能；这不影响您浏览本网站的公开信息。
        </p>
        <p>本政策将帮助您了解以下内容：</p>
        <p>
          一、定义与适用范围<br />
          二、我们如何收集和使用您的个人信息<br />
          三、我们如何使用Cookie及同类技术<br />
          四、我们如何共享、转让、公开披露您的个人信息<br />
          五、个人信息的跨境提供<br />
          六、我们如何存储和保护您的个人信息<br />
          七、您的权利及行使方式<br />
          八、我们如何处理未成年人的个人信息<br />
          九、本政策的更新<br />
          十、如何联系我们<br />
          十一、法律适用与争议解决
        </p>
      </section>

      <section class="legal-section">
        <h2>一、定义与适用范围</h2>
        <p><strong>1.1 定义</strong></p>
        <p>
          <strong>个人信息：</strong
          >指以电子或者其他方式记录的与已识别或者可识别的自然人有关的各种信息，不包括匿名化处理后的信息。
        </p>
        <p>
          <strong>敏感个人信息：</strong
          >指一旦泄露或者被非法使用，容易导致自然人的人格尊严受到侵害或者人身、财产安全受到危害的个人信息，包括生物识别、宗教信仰、特定身份、医疗健康、金融账户、行踪轨迹等信息，以及不满十四周岁未成年人的个人信息。
        </p>
        <p>
          <strong>个人信息处理者：</strong
          >指在个人信息处理活动中自主决定处理目的、处理方式的组织、个人。就本网站的个人信息处理活动而言，个人信息处理者为辰鳗科技集团有限公司。
        </p>
        <p>
          <strong>去标识化：</strong
          >指个人信息经过处理，使其在不借助额外信息的情况下无法识别特定自然人的过程。
        </p>
        <p>
          <strong>匿名化：</strong
          >指个人信息经过处理无法识别特定自然人且不能复原的过程。匿名化处理后的信息不属于个人信息。
        </p>
        <p><strong>您：</strong>指访问、浏览或使用本网站的自然人。</p>

        <p><strong>1.2 适用范围</strong></p>
        <p>
          1.2.1
          本政策适用于您对本网站的访问、浏览与使用，以及我们通过本网站收集、处理个人信息的全部活动。
        </p>
        <p>
          1.2.2
          本政策不适用于下列情形：（1）我们向客户提供的能源管理SaaS平台、移动应用、小程序、充电服务、物联网终端等产品与服务，该等产品与服务另行适用其专门的隐私政策或用户协议；（2）通过本网站链接跳转的第三方网站、平台或服务（如第三方招聘平台、第三方支付、第三方地图、第三方视频服务等），该等第三方的信息处理活动适用其自身的隐私政策，我们建议您在提供个人信息前审慎阅读。
        </p>
        <p>
          1.2.3
          我们在业务开展中处理的企业用能数据、设备运行数据、计量与监测数据等，通常属于企业数据而非个人信息；但如该等数据与特定自然人相关联且可识别到个人，我们将按照本政策及相关法律规定处理。
        </p>
      </section>

      <section class="legal-section">
        <h2>二、我们如何收集和使用您的个人信息</h2>

        <p><strong>2.1 您主动提供的个人信息</strong></p>
        <p>
          在您使用本网站下列功能时，我们会收集您主动提供的相关信息。如您不提供，可能无法使用对应功能，但不影响您浏览本网站的公开内容。
        </p>
        <p>
          （1）<strong>方案咨询与预约演示：</strong>姓名或称呼、所在单位名称、职务、手机号码、电子邮箱、所在地区，以及您描述的用能场景与业务需求。用于响应咨询、匹配对接人员、提供方案建议及后续商务沟通。
        </p>
        <p>
          （2）<strong>商务合作与供应商登记：</strong>联系人姓名、职务、联系电话、电子邮箱、单位名称及合作意向信息。用于评估合作机会、开展商务洽谈与准入审核。
        </p>
        <p>
          （3）<strong>招聘与简历投递：</strong>姓名、联系电话、电子邮箱、教育背景、工作经历、专业资质及您在简历中自愿提供的其他信息。用于岗位匹配、面试安排与录用评估。您通过第三方招聘平台投递简历的，同时适用该平台的隐私政策。
        </p>
        <p>
          （4）<strong>客户服务与工单支持：</strong>姓名、联系方式、所属单位、项目或站点名称、问题描述及您上传的图片、文档等。用于受理、处理并回访您的服务请求。
        </p>
        <p>
          （5）<strong>账号注册与登录（如本网站开通该功能）：</strong>手机号码、电子邮箱及登录密码；您可自愿补充姓名、头像、单位等信息。用于账号创建、身份验证、登录状态维持及账号安全保障。
        </p>
        <p>
          （6）<strong>活动报名与市场调研：</strong>姓名、单位、职务、联系方式；参加线下活动的，可能需要收集为完成场地或园区登记所必需的证件信息。用于活动组织、签到、通知与结果反馈。
        </p>

        <p><strong>2.2 我们自动收集的信息</strong></p>
        <p>当您访问本网站时，我们会通过技术手段自动收集下列信息：</p>
        <p>
          （1）<strong>设备信息：</strong>设备型号、操作系统及版本、浏览器类型及版本、屏幕分辨率、语言设置等。
        </p>
        <p>
          （2）<strong>日志信息：</strong>IP地址、访问时间、来源页面、访问及点击的页面、停留时长、错误日志等。
        </p>
        <p>
          （3）<strong>大致地理位置：</strong>我们可能基于IP地址判断您所处的省、市级区域，用于内容适配与区域业务对接。我们不会通过本网站收集您的精确定位（GPS）信息。
        </p>
        <p>
          上述信息用于保障网站安全稳定运行、排查技术故障、统计分析访问情况、优化页面与内容呈现。我们通常以去标识化或汇总统计的方式使用该等信息。
        </p>

        <p><strong>2.3 敏感个人信息的处理</strong></p>
        <p>
          如相关业务确需处理您的敏感个人信息（例如为完成实名认证、开具发票、办理园区或厂区准入而必需的身份证件号码、金融账户信息等），我们将在收集前以显著方式单独向您告知处理的必要性以及对您个人权益的影响，并取得您的单独同意；法律、行政法规规定应当取得书面同意的，从其规定。
        </p>

        <p><strong>2.4 征得同意的例外情形</strong></p>
        <p>
          根据《中华人民共和国个人信息保护法》第十三条等规定，在下列情形下，我们处理您的个人信息无需取得您的同意：（1）为订立、履行您作为一方当事人的合同所必需，或者按照依法制定的劳动规章制度和依法签订的集体合同实施人力资源管理所必需；（2）为履行法定职责或者法定义务所必需；（3）为应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需；（4）在合理的范围内处理您自行公开或者其他已经合法公开的个人信息；（5）为公共利益实施新闻报道、舆论监督等行为，在合理的范围内处理个人信息；（6）法律、行政法规规定的其他情形。
        </p>

        <p><strong>2.5 使用目的的变更</strong></p>
        <p>
          如我们需要将您的个人信息用于本政策未载明的其他目的，或将基于特定目的收集的信息用于其他目的，我们将事先以合理方式向您告知，并再次取得您的同意。
        </p>

        <p><strong>2.6 自动化决策与商业信息推送</strong></p>
        <p>
          我们不会通过本网站对您进行可能对个人权益产生重大影响的自动化决策，不会在交易条件上对您实行不合理的差别待遇。如我们通过自动化决策方式向您推送商业信息或进行商业营销，我们将同时提供不针对您个人特征的选项，或者向您提供便捷的拒绝方式；您也有权要求我们对该等决策予以说明。
        </p>
      </section>

      <section class="legal-section">
        <h2>三、我们如何使用Cookie及同类技术</h2>
        <p>
          3.1
          为保障本网站正常运行、提升访问体验并进行访问统计，我们会使用Cookie、像素标签、本地存储等技术，收集您的浏览偏好、登录状态、访问行为等信息。
        </p>
        <p>
          3.2
          本网站使用的Cookie主要包括：（1）必要Cookie，用于维持登录状态、保障访问安全，不可关闭；（2）功能Cookie，用于记忆语言与浏览偏好；（3）分析类Cookie，用于统计访问量与页面表现；（4）营销类Cookie。
        </p>
        <p>
          3.3
          您可以通过浏览器设置或本网站提供的Cookie管理工具（如有）拒绝、清除Cookie。请注意，拒绝必要Cookie可能导致本网站部分功能无法正常使用。
        </p>
        <p>3.4 我们不会将Cookie用于本政策所述目的之外的任何用途。</p>
      </section>

      <section class="legal-section">
        <h2>四、我们如何共享、转让、公开披露您的个人信息</h2>

        <p><strong>4.1 共享</strong></p>
        <p>我们不会与本公司以外的组织或个人共享您的个人信息，下列情形除外：</p>
        <p>（1）已取得您的单独同意；</p>
        <p>
          （2）在关联公司之间的必要共享：为实现本政策所述处理目的，我们可能与本集团关联公司（包括四川星小鳗能源有限公司、辰鳗智慧能源科技（天津）有限公司及本网站"关于我们"栏目公示的其他关联主体）共享必要的个人信息。该等关联公司须遵守与本政策同等的保护标准，如变更处理目的或方式，我们将重新征得您的同意；
        </p>
        <p>
          （3）与受托方的共享：为实现本网站功能，我们可能委托第三方处理相关信息，包括云计算与主机服务商、短信及邮件服务商、在线客服与表单系统服务商、访问统计分析服务商、招聘管理系统服务商等。我们将与受托方签订数据处理协议，明确处理目的、期限、方式、信息种类与保护措施，受托方仅得按照我们的指示处理个人信息，并接受我们的监督；
        </p>
        <p>（4）法律法规规定或者监管部门、司法机关依法要求的其他情形。</p>

        <p><strong>4.2 转让</strong></p>
        <p>
          我们不会向任何组织或个人转让您的个人信息，但下列情形除外：（1）已取得您的单独同意；（2）因合并、分立、解散、被宣告破产等原因需要转移个人信息的，我们将向您告知接收方的名称或者姓名和联系方式，由接收方继续履行个人信息处理者的义务；接收方变更原处理目的、处理方式的，应当重新取得您的同意。
        </p>

        <p><strong>4.3 公开披露</strong></p>
        <p>
          我们不会公开披露您的个人信息，但取得您的单独同意或者法律法规另有规定的除外。
        </p>

        <p><strong>4.4 依法无需取得同意的情形</strong></p>
        <p>
          根据法律法规，在为履行法定职责或者法定义务所必需、为应对突发公共卫生事件或紧急情况下保护自然人生命健康和财产安全所必需、在合理范围内处理已合法公开的个人信息、以及法律法规规定的其他情形下，我们共享、转让、公开披露您的个人信息无需事先征得您的授权同意。
        </p>
      </section>

      <section class="legal-section">
        <h2>五、个人信息的跨境提供</h2>
        <p>5.1 我们通过本网站收集和产生的个人信息，原则上存储于中华人民共和国境内。</p>
        <p>
          5.2
          如因业务需要（例如境外业务拓展、跨境项目服务、使用境外服务商等）确需向中华人民共和国境外提供个人信息的，我们将依法履行下列条件之一：（1）通过国家网信部门组织的安全评估；（2）按照国家网信部门的规定经专业机构进行个人信息保护认证；（3）按照国家网信部门制定的标准合同与境外接收方订立合同，约定双方的权利和义务；（4）法律、行政法规或者国家网信部门规定的其他条件。
        </p>
        <p>
          5.3
          在向境外提供前，我们将向您告知境外接收方的名称或者姓名、联系方式、处理目的、处理方式、个人信息的种类，以及您向境外接收方行使本政策第七条所列权利的方式和程序等事项，并取得您的单独同意。我们将采取必要措施，保障境外接收方处理个人信息的活动达到本法规定的保护标准。
        </p>
      </section>

      <section class="legal-section">
        <h2>六、我们如何存储和保护您的个人信息</h2>

        <p><strong>6.1 存储期限</strong></p>
        <p>
          我们仅在为实现本政策所述目的所必需的最短期限内存储您的个人信息，超出期限后将予以删除或者匿名化处理，法律、行政法规另有规定的除外。具体而言：
        </p>
        <p>（1）咨询、合作及活动线索信息：自您最后一次与我们联系之日起12个月；</p>
        <p>
          （2）招聘相关信息：未录用的，自招聘流程结束之日起6个月，用于同类岗位的再次匹配（您可随时要求我们提前删除）；已录用的，转为员工信息按人力资源管理相关制度与法律规定保存；
        </p>
        <p>
          （3）账号信息：在账号存续期间保存；您注销账号后，我们将及时删除或匿名化处理；
        </p>
        <p>
          （4）网络日志信息：依照《中华人民共和国网络安全法》第二十一条的规定，留存不少于六个月；
        </p>
        <p>
          （5）因订立、履行合同以及会计、税务等法定义务需要保存的信息，按照法律、行政法规规定的期限保存。
        </p>

        <p><strong>6.2 安全保护措施</strong></p>
        <p>
          （1）技术措施：对个人信息的传输采用SSL/TLS加密，对敏感个人信息采取加密存储；部署访问控制、身份鉴别、入侵检测、防病毒、数据备份与恢复等安全措施。
        </p>
        <p>
          （2）管理措施：建立个人信息保护制度与操作规程，实行分类管理与最小必要授权，对接触个人信息的人员进行权限管理、安全培训并签署保密协议。
        </p>
        <p>
          （3）合规措施：定期开展个人信息保护影响评估与合规审计，并按规定留存处理记录；按照网络安全等级保护制度的要求履行相应义务。
        </p>

        <p><strong>6.3 安全事件处置</strong></p>
        <p>
          发生或者可能发生个人信息泄露、篡改、丢失的，我们将立即采取补救措施，并按照规定告知履行个人信息保护职责的部门；除依法可以不通知的情形外，我们将以邮件、短信、电话或公告等方式告知您相关事项。
        </p>

        <p><strong>6.4 风险提示</strong></p>
        <p>
          请您理解，互联网环境并非绝对安全，我们将尽最大努力保障您的个人信息安全，但无法始终保证信息百分之百的安全。请您妥善保管账号、密码及验证码，避免向他人泄露。如您发现个人信息可能被泄露，请立即通过本政策第十条载明的方式联系我们。
        </p>
      </section>

      <section class="legal-section">
        <h2>七、您的权利及行使方式</h2>
        <p>
          根据《中华人民共和国个人信息保护法》等法律法规，您对自身个人信息享有下列权利：
        </p>
        <p>
          （1）<strong>知情权、决定权：</strong>有权知悉并决定其个人信息的处理，有权限制或者拒绝他人对其个人信息进行处理。
        </p>
        <p>（2）<strong>查阅、复制权：</strong>有权向我们查阅、复制您的个人信息。</p>
        <p>
          （3）<strong>可携带权：</strong>在符合国家网信部门规定条件的情形下，您可以请求我们将您的个人信息转移至您指定的个人信息处理者，我们将提供转移的途径。
        </p>
        <p>
          （4）<strong>更正、补充权：</strong>您发现个人信息不准确或者不完整的，有权请求我们更正、补充；我们将在核实后及时处理。
        </p>
        <p>
          （5）<strong>删除权：</strong>有下列情形之一的，我们将主动删除您的个人信息，您也有权请求删除：处理目的已实现、无法实现或者为实现处理目的不再必要；我们停止提供产品或者服务，或者保存期限已届满；您撤回同意；我们违反法律、行政法规或者违反约定处理个人信息；法律、行政法规规定的其他情形。法律、行政法规规定的保存期限未届满，或者删除个人信息从技术上难以实现的，我们将停止除存储和采取必要的安全保护措施之外的处理。
        </p>
        <p>
          （6）<strong>撤回同意权：</strong>对基于您同意而进行的处理活动，您有权随时撤回同意。撤回同意不影响撤回前基于您的同意已进行的个人信息处理活动的效力，也不影响我们基于其他合法事由继续处理必要的个人信息。
        </p>
        <p>
          （7）<strong>要求解释说明的权利：</strong>您有权要求我们对本政策及个人信息处理规则进行解释说明。
        </p>
        <p>
          （8）<strong>注销账号的权利：</strong>您有权注销本网站账号（如有），注销后我们将删除或匿名化处理您的相关个人信息。
        </p>
        <p>
          （9）<strong>投诉、举报的权利：</strong>您认为我们的个人信息处理活动侵害您合法权益的，可以向我们投诉，也可以向履行个人信息保护职责的部门投诉、举报。
        </p>
        <p>
          （10）<strong>逝者近亲属的权利：</strong>自然人死亡的，其近亲属为了自身合法、正当的利益，可以对死者的相关个人信息行使查阅、复制、更正、删除等权利，死者生前另有安排的除外。
        </p>
        <p>
          权利行使方式：您可以通过本政策第十条载明的方式向我们提出请求。为保障信息安全，我们可能需要先行核验您的身份，并要求您提供必要的证明材料。我们将在收到并核实您的请求后15个工作日内予以响应；情况复杂的，我们将向您说明理由并合理延长。我们对您的上述请求原则上不收取费用，但对不合理重复、需要过多技术手段或者存在其他不合理情形的请求，我们可能收取合理成本费用。对于依法可以拒绝的请求，我们将向您说明理由。
        </p>
      </section>

      <section class="legal-section">
        <h2>八、我们如何处理未成年人的个人信息</h2>
        <p>
          8.1
          本网站主要面向企业客户及商务人士，不以未成年人为服务对象，我们不会主动收集未成年人的个人信息。
        </p>
        <p>
          8.2
          如您为不满十八周岁的未成年人，请在监护人的陪同下阅读本政策，并在取得监护人同意后使用本网站需要提交个人信息的功能。我们处理不满十四周岁未成年人个人信息的，将取得其父母或者其他监护人的同意，并另行制定专门的个人信息处理规则。
        </p>
        <p>
          8.3
          如监护人发现未成年人未经其同意向我们提供了个人信息，请通过本政策第十条载明的方式联系我们，我们将在核实后及时删除相关信息。
        </p>
      </section>

      <section class="legal-section">
        <h2>九、本政策的更新</h2>
        <p>
          9.1
          我们可能根据法律法规的变化、业务或技术的调整对本政策进行修订。修订后的政策将在本网站显著位置公布，并标注生效日期与更新日期。
        </p>
        <p>
          9.2
          未经您明确同意，我们不会削减您依据本政策所应享有的权利。发生下列重大变更时，我们将通过弹窗提示、短信、电子邮件或站内公告等显著方式另行通知您：（1）我们的服务模式发生重大变化，导致个人信息的处理目的、种类或使用方式发生变化；（2）我们在所有权结构、组织架构等方面发生重大变化，如业务调整、并购重组导致的处理者变更；（3）个人信息共享、转让或公开披露的主要对象发生变化；（4）您参与个人信息处理方面的权利及其行使方式发生重大变化；（5）个人信息保护负责人及其联系方式发生变化；（6）个人信息保护影响评估表明存在较高风险。
        </p>
        <p>
          9.3
          如您不同意修订后的政策，您有权停止使用相应功能并撤回同意；您继续使用相关功能的，视为您接受修订后的政策。
        </p>
      </section>

      <section class="legal-section">
        <h2>十、如何联系我们</h2>
        <p>
          如您对本政策或个人信息保护有任何疑问、意见、投诉，或需要行使本政策第七条所述权利，可以通过下列方式与我们联系：
        </p>
        <ul>
          <li>个人信息保护负责人：品宣部</li>
          <li>联系电话：028-86533354</li>
          <li>电子邮箱：xiaomanguanjia@smalleel.com</li>
          <li>联系地址：四川省成都市双流区电子科大科技园（天府园区）B12栋4单元5楼</li>
          <li>在线渠道：本网站"联系我们""意见反馈"功能</li>
        </ul>
        <p>
          我们将在收到您的反馈后及时核实处理，并在15个工作日内予以回复；情况复杂的，我们将适当延长回复期限并事先告知您。
        </p>
        <p>
          如您对我们的处理结果仍不满意，您可以向网信、公安、市场监督管理等履行个人信息保护职责的部门投诉、举报，或者向有管辖权的人民法院提起诉讼。
        </p>
      </section>

      <section class="legal-section">
        <h2>十一、法律适用与争议解决</h2>
        <p>
          11.1
          本政策的订立、生效、履行、解释及争议解决，适用中华人民共和国法律（为本政策之目的，不含香港特别行政区、澳门特别行政区及台湾地区法律）。
        </p>
        <p>
          11.2
          您与我们之间因本政策产生的争议，应首先友好协商解决；协商不成的，任何一方均有权向本公司住所地有管辖权的人民法院提起诉讼。
        </p>
        <p>
          11.3
          本政策部分条款被认定为无效的，不影响其他条款的效力。本政策未尽事宜，依照相关法律法规执行。
        </p>
      </section>

      <div class="legal-footer">
        <p>辰鳗科技集团有限公司</p>
        <p>2026年8月24日</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "privacy",
  mounted() {
    document.title = "隐私政策-辰鳗科技集团-小鳗管家";
  },
};
</script>

<style scoped>
.legal-page {
  min-height: 100vh;
  background: #f5f7fa;
  padding: 40px 0 80px;
  overflow-y: auto;
}
.legal-container {
  width: 1200px;
  max-width: calc(100% - 40px);
  margin: 0 auto;
  background: #fff;
  border-radius: 8px;
  padding: 40px 60px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
}
.breadcrumb-bar {
  font-size: 14px;
  color: #969fa6;
  margin-bottom: 24px;
}
.crumb {
  cursor: pointer;
  color: #3170ff;
}
.crumb:hover {
  text-decoration: underline;
}
.sep {
  margin: 0 8px;
  color: #c0c4cc;
}
.crumb-current {
  color: #606266;
}
.legal-title {
  font-size: 28px;
  font-weight: 600;
  color: #23262a;
  margin: 0 0 8px;
  text-align: center;
}
.legal-updated {
  text-align: center;
  color: #969fa6;
  font-size: 13px;
  margin-bottom: 40px;
}
.legal-section {
  margin-bottom: 32px;
  text-align: left;
}
.legal-intro {
  margin-bottom: 16px;
}
.legal-emphasis {
  background: #fff8e1;
  border-left: 3px solid #ffa000;
  padding: 12px 16px;
  margin: 16px 0;
  border-radius: 4px;
}
.legal-section h2 {
  font-size: 18px;
  font-weight: 600;
  color: #23262a;
  margin: 0 0 12px;
  padding-left: 12px;
  border-left: 3px solid #3170ff;
}
.legal-section p {
  font-size: 14px;
  line-height: 1.9;
  color: #4a4a4a;
  margin: 8px 0;
}
.legal-section ul {
  padding-left: 24px;
  margin: 8px 0;
}
.legal-section li {
  font-size: 14px;
  line-height: 1.9;
  color: #4a4a4a;
  margin-bottom: 4px;
}
.legal-footer {
  text-align: center;
  color: #969fa6;
  font-size: 14px;
  margin-top: 48px;
  padding-top: 24px;
  border-top: 1px solid #ebeef5;
}
.legal-footer p {
  margin: 4px 0;
}
@media (max-width: 768px) {
  .legal-container {
    padding: 24px 20px;
  }
  .legal-title {
    font-size: 22px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/page/privacy.vue